<template lang="pug">
form(@submit.prevent="submit" novalidate)
  .modal-card
    header.modal-card-head
      p.modal-card-title iTunes Settings
    section.modal-card-body.modal-tabs
      b-tabs(
        position="is-centered"
        expanded
      )
        b-tab-item(label="Feed")
          b-field(label="Author")
            b-input(
              :value="account.itunes.author"
              @input="set($event, 'author')"
            )
          b-field(label="Owner Name")
            b-input(
              :value="account.itunes.owner.name"
              @input="set($event, 'owner.name')"
            )
          b-field(label="Owner Email")
            b-input(
              icon="email"
              type="email"
              :value="account.itunes.owner.email"
              @input="set($event, 'owner.email')"
            )
          b-field(label="Keywords")
            b-taginput(
              type="is-primary"
              :value="account.itunes.keywords"
              @input="set($event, 'keywords')"
              allow-new
            )
          b-field(label="Description")
            b-input(
              type="textarea"
              rows="5"
              :value="account.itunes.desc"
              @input="set($event, 'desc')"
            )
        b-tab-item(label="Artwork")
          cover-art-tab(
            v-model="image"
            :default-image="defaultImage"
            :height="293"
            :width="293"
            @input="img => image = img"
          )
    footer.modal-card-foot
      button.button.is-success(
        type="submit"
        :class="{ 'is-loading': settings.submitting }"
      ) Save iTunes Settings
</template>

<script>
import { mapGetters } from 'vuex';
import CoverArtTab from '@/components/form/episode/CoverArtTab';
import * as actions from '@/store/types/actions';
import * as getters from '@/store/types/getters';
import * as mutations from '@/store/types/mutations';

export default {
  name: 'podcast-settings-form',
  components: {
    CoverArtTab,
  },
  computed: {
    ...mapGetters({
      account: getters.GET_ACCOUNT,
    }),
    defaultImage() {
      if (this.account.itunes.image.id) {
        return this.account.itunes.image.file.url;
      }
      return null;
    },
  },
  data() {
    return {
      image: null,
      settings: {
        submitting: false,
      },
    };
  },
  methods: {
    set(val, key) {
      this.$store.commit(mutations.SET_ACCOUNT_FIELD, {
        key: `itunes.${key}`,
        val,
      });
    },
    async submit() {
      const valid = await this.$validator.validateAll();
      if (valid) {
        this.settings.submitting = true;
        const payload = {
          id: this.account.id,
          itunes_author: this.account.itunes.author,
          itunes_desc: this.account.itunes.desc,
          itunes_keywords: this.account.itunes.keywords.join(','),
          itunes_owner_email: this.account.itunes.owner.email,
          itunes_owner_name: this.account.itunes.owner.name,
        };
        if (this.image) {
          const file = this.image.generateDataUrl('image/jpeg');
          const { data } = await this.$store.dispatch(actions.DO_CREATE_MEDIA_IMAGE, { file });
          payload.itunes_image_id = data.images[0].id;
        }
        const response = await this.$store.dispatch(actions.DO_UPDATE_ACCOUNT, payload);
        this.$parent.close();
        this.$store.commit(mutations.SET_APP_SNACKBAR, {
          type: 'is-success',
          message: response.message,
        });
        this.settings.submitting = false;
      }
    },
  },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/form/PodcastSettingsForm.vue